import { z } from 'zod';
import { ExperienceCreatedFrom } from '../enums';

export const QuarkExperiences = z.object({
  id: z.string().uuid(),
  user_id: z.string().uuid(),
  designation_code: z.string().nullable(),
  designation_referential_id: z.string().uuid().nullable(),
  custom_name: z.string().nullable(),
  type_id: z.string().uuid().nullable(),
  start_at: z.string().nullable(),
  end_at: z.string().nullable(),
  duration: z.number().nullable(),
  company: z.string().nullable(),
  place: z.string().nullable(),
  on_going: z.boolean().nullable(),
  abroad: z.boolean().nullable(),
  is_visible: z.boolean(),
  is_wish: z.boolean(),
  favorite: z.number().int().nullable(),
  description: z.string().nullable(),
  rank: z.number().nullable(),
  created_from: ExperienceCreatedFrom,
  created_at: z.string(),
  updated_at: z.string(),
});

export type QuarkExperiencesT = z.infer<typeof QuarkExperiences>;

export const QuarkExperiencesInsert = QuarkExperiences.partial();

export type QuarkExperiencesInsertT = z.infer<typeof QuarkExperiencesInsert>;

export const QuarkExperiencesUpdate = QuarkExperiences.omit({
  id: true,
  created_at: true,
}).partial();

export type QuarkExperiencesUpdateT = z.infer<typeof QuarkExperiencesUpdate>;
